var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHourglassSimpleLow = function SvgIconHourglassSimpleLow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.558 2.75h12.884a1.75 1.75 0 0 1 1.229 2.994L13.414 12l3.785 3.785.016.016 2.456 2.455a1.75 1.75 0 0 1-1.229 2.994H5.558a1.75 1.75 0 0 1-1.229-2.994L10.586 12 4.329 5.744A1.75 1.75 0 0 1 5.558 2.75m8.528 12.75L12 13.414 9.914 15.5zm-6.172 2h8.172l1.75 1.75H6.164zM6.164 4.75 12 10.586l5.836-5.836z",
    clipRule: "evenodd"
  })));
};
export default SvgIconHourglassSimpleLow;